import { ExamCentersTypes } from '../../../constants/ExamCenters';

export const EXAM_CENTERS_TYPES_FILTERS = [
  {
    label: 'Tous',
    value: ExamCentersTypes.ALL,
  },
  {
    label: 'Codengo',
    value: ExamCentersTypes.CODENGO,
  },
  {
    label: 'Dekra',
    value: ExamCentersTypes.DEKRA,
  },
  {
    label: 'La Poste',
    value: ExamCentersTypes.LAPOSTE,
  },
  {
    label: 'Pointcode',
    value: ExamCentersTypes.POINTCODE,
  },
  {
    label: 'ObjectifCode',
    value: ExamCentersTypes.SGS,
  },
  // {
  //   label: 'Exacode',
  //   value: ExamCentersTypes.EXACODE,
  // },
  // {
  //   label: 'France Code',
  //   value: ExamCentersTypes.FRANCECODE,
  // },
];

export const ExamCentersSortTypes = {
  SESSION: 'SESSION',
  DISTANCE: 'DISTANCE',
};

export const EXAM_CENTERS_SORT_FILTERS = [
  {
    label: 'Proximité',
    value: ExamCentersSortTypes.DISTANCE,
  },
  {
    label: 'Prochaine session',
    value: ExamCentersSortTypes.SESSION,
  },
];
